import { Navigate, Route, Routes } from 'react-router-dom'
import { ForumShell } from '@/components/layout/ForumShell'
import { AdminPage } from '@/pages/AdminPage'
import { BookmarksPage } from '@/pages/BookmarksPage'
import { CategoryPage } from '@/pages/CategoryPage'
import { EditPostPage } from '@/pages/EditPostPage'
import { GuidelinesPage } from '@/pages/GuidelinesPage'
import { DiscussionsPage } from '@/pages/DiscussionsPage'
import { HomePage } from '@/pages/HomePage'
import { NewThreadPage } from '@/pages/NewThreadPage'
import { ProfilePage } from '@/pages/ProfilePage'
import { SettingsPage } from '@/pages/SettingsPage'
import { SignInPage } from '@/pages/SignInPage'
import { SignUpPage } from '@/pages/SignUpPage'
import { ThreadPage } from '@/pages/ThreadPage'

export function App() {
  return (
    <div className="flex min-h-0 flex-1 flex-col">
      <Routes>
        <Route element={<ForumShell />}>
          <Route index element={<HomePage />} />
          <Route path="discussions" element={<DiscussionsPage />} />
          <Route path="c/:slug" element={<CategoryPage />} />
          <Route path="t/:slug" element={<ThreadPage />} />
          <Route path="new" element={<NewThreadPage />} />
          <Route path="posts/:postId/edit" element={<EditPostPage />} />
          <Route path="u/:username" element={<ProfilePage />} />
          <Route path="bookmarks" element={<BookmarksPage />} />
          <Route path="settings" element={<SettingsPage />} />
          <Route path="admin" element={<AdminPage />} />
          <Route path="guidelines" element={<GuidelinesPage />} />
        </Route>

        <Route path="sign-in" element={<SignInPage />} />
        <Route path="sign-up" element={<SignUpPage />} />

        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </div>
  )
}
